import React from 'react'
import ShippingStorePage from '../store'
import { useParams } from 'react-router-dom'

const EditCompanyDelivery = () => {
    const {id}=useParams()  
    const  mode ="edit"
      return (   
    <div>   
        <ShippingStorePage mode={mode} id={id}/>
          
    </div>  
  )
}

export default EditCompanyDelivery